<script>
import ValidationMixin from "@/mixins/validation.mixin";
import { FacilityType, FacilityTypeMap } from "@/constants/facility";

export default {
  name: "SelectFacilityType",
  mixins: [ValidationMixin],
  props: {
    modelValue: null,
    required: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      options: FacilityTypeMap,
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  mounted() {
    if (!this.model) {
      this.model = FacilityType.standard;
    }
  },
};
</script>

<template>
  <v-select
    v-model="model"
    :class="{ required: required }"
    :disabled="disabled"
    :items="options"
    :rules="required ? [requiredValidator] : []"
    autocomplete="off"
    color="primary"
    density="compact"
    hide-details="auto"
    item-title="name"
    item-value="id"
    label="Type"
    variant="outlined"
  />
</template>

<style lang="scss" scoped></style>
